import { TaipeiDate } from "../../../../../utils/taipeiDate.js";
import { REGION_TYPE, SWITCHER_STATUS_TYPE } from "@/lib/variables";

/**
 * @function ApiClient#EquipmentOperationEfficiency
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assetId = ""
 * @param {any} startMonth = new TaipeiDate().getMonth() + 1
 * @param {any} endMonth = new TaipeiDate().getMonth() + 1
 * @param {any} options = {}
 */
export async function EquipmentOperationEfficiency(
  cid,
  assetId = "",
  startMonth = new TaipeiDate().getMonth() + 1,
  endMonth = new TaipeiDate().getMonth() + 1,
  options = {},
) {
  const args = {
    "startMonth=": startMonth,
    "endMonth=": endMonth,
  };
  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/analyze/equipment_operation_efficiency/${assetId}`);
  return await this._get(url, options);
}

/**
 * @function ApiClient#EquipmentLifeCycle
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assetId = ""
 * @param {any} options = {}
 */
export async function EquipmentLifeCycle(cid, assetId = "", options = {}) {
  return await this._get(`/community/${cid}/analyze/equipment_life_cycle/${assetId}`, options);
}

/**
 * @function ApiClient#EquipmentOperationAnalysis
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assets = []
 * @param {any} startMonth = new TaipeiDate().getMonth() + 1
 * @param {any} endMonth = new TaipeiDate().getMonth() + 1
 * @param {any} options = {}
 */
export async function EquipmentOperationAnalysis(
  cid,
  assets = [],
  startMonth = new TaipeiDate().getMonth() + 1,
  endMonth = new TaipeiDate().getMonth() + 1,
  options = {},
) {
  const args = {
    "assets=": assets.length > 0 ? assets.join(",") : "",
    "startMonth=": startMonth,
    "endMonth=": endMonth,
  };
  // const url = Object.keys(args).reduce((acc, value, index) => {
  //   return acc + (index === 0 ? "?" : "&") + value + args[value];
  // }, `/community/${cid}/analyze/equipment_operation_analysis`);
  // return await this._get(url, options);
  console.log("args", args);
  console.log("options", options);
  return {
    // FIXME 假資料
    MonthStats: [
      {
        ID: "67fb571b93fc35b6e990848b",
        WorkOrderNo: "W20250413141803",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "67e7a689bc811b7a2f309352",
            ReportNo: "R20250329155137952",
          },
        ],
        Places: [
          {
            id: "64b6282b75d02688edc20c41",
            Name: "B1機房",
          },
          {
            id: "66b18e2caf49992d05dfdde4",
            Name: "2樓閱覽室",
          },
        ],
        Assets: ["64c872d7b02062f9ab098f2c", "64c7597bcb9654295f79fd60", "64bf9cdc0f65e39fc8639fc2"],
        Workers: [],
        Description: "",
        StartDate: "2025-04-15T09:00:00Z",
        EndDate: "2025-04-15T15:00:00Z",
        Status: 2,
        Created: "2025-04-13T06:18:03.853Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "2025-05-01T10:15:21.3Z",
        Updater: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "67fb5e573475af1a0d24d5fd",
        WorkOrderNo: "W20250413144855",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778f59f1ba5e99eb4482ee6",
            ReportNo: "R20250104164727174",
          },
        ],
        Places: [
          {
            id: "64b6285a75d02688edc20c43",
            Name: "櫃檯",
          },
          {
            id: "64b6107475d02688edc20c3f",
            Name: "2樓咖啡廳",
          },
        ],
        Assets: ["64bf682d2044d08d42839666", "64c7554125c714bcef8f63f5"],
        Workers: [
          {
            id: "65000df450bdce8a3455af95",
            Name: "梁伃評",
            Department: "保全",
            Tel: "46382093#881",
            Phone: "0982747637",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 2,
        Created: "2025-04-13T06:48:55.68Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "2025-04-21T16:11:46.147Z",
      },
      {
        ID: "67fb5e8e93fc35b6e990848c",
        WorkOrderNo: "W20250413144950",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "67e81d7701269cdfe61ee967",
            ReportNo: "R20250330001903545",
          },
        ],
        Places: [
          {
            id: "64b6107475d02688edc20c3f",
            Name: "2樓咖啡廳",
          },
          {
            id: "64b6282b75d02688edc20c41",
            Name: "B1機房",
          },
        ],
        Assets: ["64c7554125c714bcef8f63f5"],
        Workers: [
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
          {
            id: "65000df450bdce8a3455af94",
            Name: "詹蓁宥",
            Department: "行政",
            Tel: "37582839",
            Phone: "0957382731",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-13T06:49:50.765Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "67fb5eccf03fd34b7855c07b",
        WorkOrderNo: "W20250413145052",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "67e81d7701269cdfe61ee967",
            ReportNo: "R20250330001903545",
          },
        ],
        Places: [
          {
            id: "64c872e3b02062f9ab098f2d",
            Name: "頂樓",
          },
        ],
        Assets: ["64c7554125c714bcef8f63f5", "64c7597bcb9654295f79fd60"],
        Workers: [
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
          {
            id: "65000df450bdce8a3455af95",
            Name: "梁伃評",
            Department: "保全",
            Tel: "46382093#881",
            Phone: "0982747637",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-13T06:50:52.141Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "67fb5f7c3475af1a0d24d5fe",
        WorkOrderNo: "W20250413145348",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "67e7a689bc811b7a2f309352",
            ReportNo: "R20250329155137952",
          },
        ],
        Places: [
          {
            id: "64b6282b75d02688edc20c41",
            Name: "B1機房",
          },
        ],
        Assets: ["64c872d7b02062f9ab098f2c"],
        Workers: [
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
          {
            id: "65000df450bdce8a3455af96",
            Name: "曾哿垾",
            Department: "清潔",
            Tel: "27472733",
            Phone: "0927521627",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-13T06:53:48.787Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "67fbd2f7e74708aef6b8437d",
        WorkOrderNo: "W20250413230631",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778fe420803a34295fa25d5",
            ReportNo: "R20250104172417579",
          },
          {
            ID: "67e8eccbe67f0bd20103eee5",
            ReportNo: "R20250330150339002",
          },
        ],
        Places: [
          {
            id: "64b6107475d02688edc20c3f",
            Name: "2樓咖啡廳",
          },
          {
            id: "66b18e2caf49992d05dfdde4",
            Name: "2樓閱覽室",
          },
          {
            id: "64b6106e75d02688edc20c3e",
            Name: "2樓儲藏室",
          },
        ],
        Assets: ["64c7554125c714bcef8f63f5", "64c872d7b02062f9ab098f2c", "64c7597bcb9654295f79fd60"],
        Workers: [
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
          {
            id: "65000df450bdce8a3455af96",
            Name: "曾哿垾",
            Department: "清潔",
            Tel: "27472733",
            Phone: "0927521627",
          },
          {
            id: "65000df450bdce8a3455af95",
            Name: "梁伃評",
            Department: "保全",
            Tel: "46382093#881",
            Phone: "0982747637",
          },
        ],
        Description: "去重測試",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-13T15:06:31.822Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "67fbd2ffe74708aef6b8437e",
        WorkOrderNo: "W20250413230639",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778fe420803a34295fa25d5",
            ReportNo: "R20250104172417579",
          },
          {
            ID: "67e8eccbe67f0bd20103eee5",
            ReportNo: "R20250330150339002",
          },
        ],
        Places: [
          {
            id: "64b6107475d02688edc20c3f",
            Name: "2樓咖啡廳",
          },
          {
            id: "66b18e2caf49992d05dfdde4",
            Name: "2樓閱覽室",
          },
          {
            id: "64b6106e75d02688edc20c3e",
            Name: "2樓儲藏室",
          },
        ],
        Assets: ["64c7554125c714bcef8f63f5", "64c872d7b02062f9ab098f2c", "64c7597bcb9654295f79fd60"],
        Workers: [
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
          {
            id: "65000df450bdce8a3455af96",
            Name: "曾哿垾",
            Department: "清潔",
            Tel: "27472733",
            Phone: "0927521627",
          },
          {
            id: "65000df450bdce8a3455af95",
            Name: "梁伃評",
            Department: "保全",
            Tel: "46382093#881",
            Phone: "0982747637",
          },
        ],
        Description: "去重測試",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-13T15:06:39.263Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "67fbfae6057bf264beb3c800",
        WorkOrderNo: "W20250414015653",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "67e81d7701269cdfe61ee967",
            ReportNo: "R20250330001903545",
          },
        ],
        Places: [
          {
            id: "64b6107475d02688edc20c3f",
            Name: "2樓咖啡廳",
          },
          {
            id: "64b6282b75d02688edc20c41",
            Name: "B1機房",
          },
          {
            id: "64b6106e75d02688edc20c3e",
            Name: "2樓儲藏室",
          },
        ],
        Assets: ["64c872d7b02062f9ab098f2c", "64c7597bcb9654295f79fd60"],
        Workers: [],
        Vendor: "64c38ca406a268304d4116c6",
        Contract: {
          ID: "678d2b5cf911069498b7ef9f",
          Description: "測試合約測試合約測試合約",
          Vendor: {
            id: "64c38ca406a268304d4116c6",
            Name: "測試廠商Ａ",
            Title: "asdasd",
            Contact: "Mary",
            Tel: "asdasd",
            Phone: "0911-222-333",
            Email: "asdasd",
            Address: "asdasd",
          },
        },
        Description: "廠商測試",
        StartDate: "2025-04-14T00:00:00Z",
        EndDate: "2025-04-18T15:59:59.999Z",
        Status: 1,
        Created: "2025-04-13T17:56:53.999Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "0001-01-01T00:00:00Z",
      },
      {
        ID: "68074a0cc712f28708bc640a",
        WorkOrderNo: "W20250422154932",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778fe420803a34295fa25d5",
            ReportNo: "R20250104172417579",
          },
        ],
        Places: [
          {
            id: "64c872e3b02062f9ab098f2d",
            Name: "頂樓",
          },
          {
            id: "64b6285a75d02688edc20c43",
            Name: "櫃檯",
          },
          {
            id: "64b6282b75d02688edc20c41",
            Name: "B1機房",
          },
        ],
        Assets: ["64c7554125c714bcef8f63f5"],
        Workers: [
          {
            id: "65000df450bdce8a3455af98",
            Name: "蘇渝莉",
            Department: "行政",
            Tel: "37582839",
            Phone: "0957382731",
          },
          {
            id: "65000df450bdce8a3455af96",
            Name: "曾哿垾",
            Department: "清潔",
            Tel: "27472733",
            Phone: "0927521627",
          },
        ],
        Description: "tt",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-22T07:49:32.328Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "2025-04-23T16:04:39.717Z",
        Updater: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "68090fc381a681410011ac1b",
        WorkOrderNo: "W20250424000523",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778fe420803a34295fa25d5",
            ReportNo: "R20250104172417579",
          },
          {
            ID: "6778ff000803a34295fa25d6",
            ReportNo: "R20250104172727583",
          },
        ],
        Places: [
          {
            id: "64b6109575d02688edc20c40",
            Name: "1樓倉庫",
          },
          {
            id: "66b18e60af49992d05dfdde5",
            Name: "B1F中央監控室",
          },
          {
            id: "64c872e3b02062f9ab098f2d",
            Name: "頂樓",
          },
        ],
        Assets: ["64c7597bcb9654295f79fd60"],
        Workers: [
          {
            id: "65000df450bdce8a3455af98",
            Name: "蘇渝莉",
            Department: "行政",
            Tel: "37582839",
            Phone: "0957382731",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-04-23T16:05:23.716Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
        Updated: "2025-04-23T16:22:08.127Z",
        Updater: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "680913eb3be921e2e778104f",
        WorkOrderNo: "W20250424002307",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778f45c1ba5e99eb4482ee5",
            ReportNo: "R20250104164203972",
          },
        ],
        Places: [
          {
            id: "64b6109575d02688edc20c40",
            Name: "1樓倉庫",
          },
          {
            id: "64b6106e75d02688edc20c3e",
            Name: "2樓儲藏室",
          },
        ],
        Assets: ["64c872d7b02062f9ab098f2c"],
        Workers: [],
        Vendor: "64c38ca406a268304d4116c6",
        Contract: {
          ID: "678d2b5cf911069498b7ef9f",
          Description: "測試合約測試合約測試合約",
          Vendor: {
            id: "64c38ca406a268304d4116c6",
            Name: "測試廠商Ａ",
            Title: "asdasd",
            Contact: "Mary",
            Tel: "asdasd",
            Phone: "0911-222-333",
            Email: "asdasd",
            Address: "asdasd",
          },
        },
        Description: "",
        StartDate: "2025-04-26T00:00:00Z",
        EndDate: "2025-04-30T15:59:59.999Z",
        Status: 1,
        Created: "2025-04-23T16:23:07.635Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "68185cba4153fa2f5e532976",
        WorkOrderNo: "W20250505143746",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778ff000803a34295fa25d6",
            ReportNo: "R20250104172727583",
          },
        ],
        Places: [
          {
            id: "66b18e2caf49992d05dfdde4",
            Name: "2樓閱覽室",
          },
          {
            id: "66b18e60af49992d05dfdde5",
            Name: "B1F中央監控室",
          },
        ],
        Assets: ["64c093fc51d2cee5762c28b3", "64c7554125c714bcef8f63f5"],
        Workers: [
          {
            id: "6800b3ff748b3ce045315326",
            Name: "路人甲",
            Department: "保全",
            Tel: "",
            Phone: "0923939292",
          },
        ],
        Description: "123",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-05-05T06:37:46.231Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "68276801c3d0dc212387d26e",
        WorkOrderNo: "W20250517002953",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778ff000803a34295fa25d6",
            ReportNo: "R20250104172727583",
          },
        ],
        Places: [
          {
            id: "64b6109575d02688edc20c40",
            Name: "1樓倉庫",
          },
        ],
        Assets: ["64bf9cdc0f65e39fc8639fc2", "64bf682d2044d08d42839666"],
        Workers: [],
        Vendor: "64c38ca406a268304d4116c6",
        Contract: {
          ID: "678d2b5cf911069498b7ef9f",
          Description: "測試合約測試合約測試合約",
          Vendor: {
            id: "64c38ca406a268304d4116c6",
            Name: "測試廠商Ａ",
            Title: "asdasd",
            Contact: "Mary",
            Tel: "asdasd",
            Phone: "0911-222-333",
            Email: "asdasd",
            Address: "asdasd",
          },
        },
        Description: "",
        StartDate: "2024-11-06T00:00:00Z",
        EndDate: "2025-05-06T15:59:59.999Z",
        Status: 1,
        Created: "2025-05-16T16:29:53.838Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
      {
        ID: "68276ca325c7f38e372cb376",
        WorkOrderNo: "W20250517004939",
        Community: "63b9b8452cb6973afe2b988f",
        Reports: [
          {
            ID: "6778fe420803a34295fa25d5",
            ReportNo: "R20250104172417579",
          },
        ],
        Places: [
          {
            id: "64b6109575d02688edc20c40",
            Name: "1樓倉庫",
          },
        ],
        Assets: ["64c093fc51d2cee5762c28b3", "64bf682d2044d08d42839666"],
        Workers: [
          {
            id: "6800b3ff748b3ce045315326",
            Name: "路人甲",
            Department: "保全",
            Tel: "",
            Phone: "0923939292",
          },
          {
            id: "65000df450bdce8a3455af97",
            Name: "湯琇鈴",
            Department: "管理中心",
            Tel: "27534703#13",
            Phone: "0923472631",
          },
        ],
        Description: "",
        StartDate: "0001-01-01T00:00:00Z",
        EndDate: "0001-01-01T00:00:00Z",
        Status: 1,
        Created: "2025-05-16T16:49:39.165Z",
        Creator: {
          id: "63bcd1b7cb5ee4feec0b2a0e",
          Name: "陳小華",
          PrivateNotify: true,
          phone: "0987654321",
        },
      },
    ].reduce((acc, item) => {
      if (!item || !item.Vendor || item.Vendor === "") return acc;
      item.LifeLength = 3;
      item.Date = "2025-04-30T16:00:00Z";
      item.WarrantyType = "全責";
      item.WarrantyStartDate = "2025-05-14T16:00:00Z";
      item.WarrantyEndDate = "2025-05-30T16:00:00Z";
      item.ProcessStatus = 1;
      item.ProcessDate = "2025-05-01T16:00:00Z";
      item.Count = 5;
      // console.log("item", item);
      acc.push(item);
      return acc;
    }, []),
  };
}

let fackOperationControl = [
  {
    id: "64c872d7b02062f9ab098f2c",
    name: "智慧路燈_1",
    status: SWITCHER_STATUS_TYPE.ON,
    regionType: REGION_TYPE.PUBLIC_LIGHTING,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
  {
    id: "64c7554125c714bcef8f63f5",
    name: "智慧路燈_2",
    status: SWITCHER_STATUS_TYPE.ON,
    regionType: REGION_TYPE.PUBLIC_LIGHTING,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
  {
    id: "64c7597bcb9654295f79fd60",
    name: "智慧路燈_3",
    status: SWITCHER_STATUS_TYPE.OFF,
    regionType: REGION_TYPE.PUBLIC_LIGHTING,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
  {
    id: "64bf9cdc0f65e39fc8639fc2",
    name: "閘門_A1",
    oneWaySwitch: true,
    regionType: REGION_TYPE.PARKING_LOT,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
  {
    id: "64c872e3b02062f9ab098f2d",
    name: "閘門_A2",
    oneWaySwitch: true,
    regionType: REGION_TYPE.PARKING_LOT,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
  {
    id: "64c38ca406a268304d4116c6",
    name: "大廳門禁",
    oneWaySwitch: true,
    regionType: REGION_TYPE.ENTRANCE,
    lastUpdated: "2025-05-01T10:15:21.3Z",
  },
];

/**
 * @function ApiClient#GetEquipmentOperationControl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} regionType
 * @param {any} switchType
 */
export async function GetEquipmentOperationControl(cid, regionType, switchType) {
  const args = {
    "regionType=": regionType, // 區域類型
    "switchType=": switchType, // 開關類型
  };
  console.log("cid", cid);
  console.log("args", args);
  // const url = Object.keys(args).reduce((acc, value, index) => {
  //   return acc + (index === 0 ? "?" : "&") + value + args[value];
  // }, `/community/${cid}/analyze/equipment_operation_control`);
  // return await this._get(url, options);
  return fackOperationControl;
}

/**
 * @function ApiClient#TriggerEquipmentSwitch
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id = ""
 * @param {any} payload
 * @param {any} options = {}
 */
export async function TriggerEquipmentSwitch(cid, id = "", payload, options = {}) {
  if (!cid || !id || !payload) {
    throw new Error("Missing required parameters: cid, id, or payload");
  }
  const equipment = fackOperationControl.find((item) => item.id === id);
  if (!equipment) throw new Error(`Equipment with id ${id} not found`);

  console.log("TriggerEquipmentSwitch", { cid, id, payload, options });
  if (equipment.oneWaySwitch) {
    // trigger one-way switch...
  } else {
    equipment.status = equipment.status === 1 ? 0 : 1;
  }

  // rewrite fakeOperationControl
  equipment.lastUpdated = new TaipeiDate().toISOString();
  fackOperationControl = fackOperationControl.map((item) => {
    if (item.id === id) return { ...equipment };
    return item;
  });

  // return await this._put(`/community/${cid}/analyze/equipment_operation_control/switch/${id}`, payload, options);
  return {
    success: true,
    message: `Equipment with id ${id} has been successfully updated.`,
    equipment: { ...equipment },
  };
}

/**
 * @function ApiClient#EnergyConsumptionData
 * @this {ApiClient}
 * @param {any} cid = ""
 * @param {any} month = new TaipeiDate().getMonth() + 1
 * @param {any} building
 * @param {any} options = {}
 */
export async function EnergyConsumptionData(cid = "", month = new TaipeiDate().getMonth() + 1, building, options = {}) {
  console.log(cid, month, options);

  // 電electricity/水water/燃氣gas
  return [
    {
      floor: 1,
      currentUsage: { water: 120, electricity: 850, gas: 60 },
      lastYearUsage: { water: 110, electricity: 800, gas: 55 },
      lastMonthUsage: { water: 115, electricity: 820, gas: 58 }, // 新增：上月總用量
      units: [
        {
          unit: "101戶",
          water: 40,
          electricity: 300,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 280,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 290,
          lastMonthGas: 19,
        },
        {
          unit: "102戶",
          water: 50,
          electricity: 350,
          gas: 25,
          lastYearWater: 45,
          lastYearElectricity: 320,
          lastYearGas: 22,
          lastMonthWater: 48,
          lastMonthElectricity: 340,
          lastMonthGas: 24,
        },
        {
          unit: "103戶",
          water: 30,
          electricity: 200,
          gas: 15,
          lastYearWater: 28,
          lastYearElectricity: 190,
          lastYearGas: 13,
          lastMonthWater: 29,
          lastMonthElectricity: 195,
          lastMonthGas: 14,
        },
        {
          unit: "104戶",
          water: 35,
          electricity: 280,
          gas: 18,
          lastYearWater: 32,
          lastYearElectricity: 260,
          lastYearGas: 16,
          lastMonthWater: 34,
          lastMonthElectricity: 270,
          lastMonthGas: 17,
        },
        {
          unit: "105戶",
          water: 42,
          electricity: 310,
          gas: 22,
          lastYearWater: 40,
          lastYearElectricity: 290,
          lastYearGas: 20,
          lastMonthWater: 41,
          lastMonthElectricity: 300,
          lastMonthGas: 21,
        },
        {
          unit: "106戶",
          water: 28,
          electricity: 190,
          gas: 14,
          lastYearWater: 25,
          lastYearElectricity: 180,
          lastYearGas: 12,
          lastMonthWater: 27,
          lastMonthElectricity: 185,
          lastMonthGas: 13,
        },
      ],
    },
    {
      floor: 2,
      currentUsage: { water: 150, electricity: 780, gas: 75 },
      lastYearUsage: { water: 140, electricity: 750, gas: 70 },
      lastMonthUsage: { water: 145, electricity: 760, gas: 72 },
      units: [
        {
          unit: "201戶",
          water: 60,
          electricity: 280,
          gas: 30,
          lastYearWater: 58,
          lastYearElectricity: 270,
          lastYearGas: 28,
          lastMonthWater: 59,
          lastMonthElectricity: 275,
          lastMonthGas: 29,
        },
        {
          unit: "202戶",
          water: 45,
          electricity: 250,
          gas: 20,
          lastYearWater: 42,
          lastYearElectricity: 240,
          lastYearGas: 18,
          lastMonthWater: 44,
          lastMonthElectricity: 245,
          lastMonthGas: 19,
        },
        {
          unit: "203戶",
          water: 45,
          electricity: 250,
          gas: 25,
          lastYearWater: 40,
          lastYearElectricity: 230,
          lastYearGas: 22,
          lastMonthWater: 43,
          lastMonthElectricity: 240,
          lastMonthGas: 23,
        },
        {
          unit: "204戶",
          water: 55,
          electricity: 300,
          gas: 28,
          lastYearWater: 50,
          lastYearElectricity: 280,
          lastYearGas: 25,
          lastMonthWater: 53,
          lastMonthElectricity: 290,
          lastMonthGas: 27,
        },
        {
          unit: "205戶",
          water: 40,
          electricity: 220,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 200,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 210,
          lastMonthGas: 19,
        },
        {
          unit: "206戶",
          water: 50,
          electricity: 270,
          gas: 24,
          lastYearWater: 48,
          lastYearElectricity: 250,
          lastYearGas: 22,
          lastMonthWater: 49,
          lastMonthElectricity: 260,
          lastMonthGas: 23,
        },
      ],
    },
    {
      floor: 3,
      currentUsage: { water: 100, electricity: 920, gas: 50 },
      lastYearUsage: { water: 95, electricity: 880, gas: 48 },
      lastMonthUsage: { water: 98, electricity: 900, gas: 49 },
      units: [
        {
          unit: "301戶",
          water: 35,
          electricity: 310,
          gas: 18,
          lastYearWater: 32,
          lastYearElectricity: 290,
          lastYearGas: 16,
          lastMonthWater: 34,
          lastMonthElectricity: 300,
          lastMonthGas: 17,
        },
        {
          unit: "302戶",
          water: 30,
          electricity: 320,
          gas: 17,
          lastYearWater: 28,
          lastYearElectricity: 300,
          lastYearGas: 15,
          lastMonthWater: 29,
          lastMonthElectricity: 310,
          lastMonthGas: 16,
        },
        {
          unit: "303戶",
          water: 35,
          electricity: 290,
          gas: 15,
          lastYearWater: 30,
          lastYearElectricity: 270,
          lastYearGas: 13,
          lastMonthWater: 34,
          lastMonthElectricity: 280,
          lastMonthGas: 14,
        },
        {
          unit: "304戶",
          water: 28,
          electricity: 280,
          gas: 12,
          lastYearWater: 25,
          lastYearElectricity: 260,
          lastYearGas: 10,
          lastMonthWater: 27,
          lastMonthElectricity: 270,
          lastMonthGas: 11,
        },
        {
          unit: "305戶",
          water: 38,
          electricity: 350,
          gas: 20,
          lastYearWater: 35,
          lastYearElectricity: 330,
          lastYearGas: 18,
          lastMonthWater: 37,
          lastMonthElectricity: 340,
          lastMonthGas: 19,
        },
        {
          unit: "306戶",
          water: 32,
          electricity: 260,
          gas: 16,
          lastYearWater: 30,
          lastYearElectricity: 240,
          lastYearGas: 14,
          lastMonthWater: 31,
          lastMonthElectricity: 250,
          lastMonthGas: 15,
        },
      ],
    },
    {
      floor: 4,
      currentUsage: { water: 130, electricity: 800, gas: 65 },
      lastYearUsage: { water: 125, electricity: 780, gas: 60 },
      lastMonthUsage: { water: 128, electricity: 790, gas: 63 },
      units: [
        {
          unit: "401戶",
          water: 50,
          electricity: 280,
          gas: 25,
          lastYearWater: 48,
          lastYearElectricity: 270,
          lastYearGas: 23,
          lastMonthWater: 49,
          lastMonthElectricity: 275,
          lastMonthGas: 24,
        },
        {
          unit: "402戶",
          water: 40,
          electricity: 270,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 250,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 260,
          lastMonthGas: 19,
        },
        {
          unit: "403戶",
          water: 40,
          electricity: 250,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 230,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 240,
          lastMonthGas: 19,
        },
        {
          unit: "404戶",
          water: 35,
          electricity: 220,
          gas: 18,
          lastYearWater: 32,
          lastYearElectricity: 200,
          lastYearGas: 16,
          lastMonthWater: 34,
          lastMonthElectricity: 210,
          lastMonthGas: 17,
        },
        {
          unit: "405戶",
          water: 48,
          electricity: 300,
          gas: 22,
          lastYearWater: 45,
          lastYearElectricity: 280,
          lastYearGas: 20,
          lastMonthWater: 47,
          lastMonthElectricity: 290,
          lastMonthGas: 21,
        },
        {
          unit: "406戶",
          water: 30,
          electricity: 200,
          gas: 15,
          lastYearWater: 28,
          lastYearElectricity: 180,
          lastYearGas: 13,
          lastMonthWater: 29,
          lastMonthElectricity: 190,
          lastMonthGas: 14,
        },
      ],
    },
    {
      floor: 5,
      currentUsage: { water: 110, electricity: 880, gas: 55 },
      lastYearUsage: { water: 105, electricity: 850, gas: 50 },
      lastMonthUsage: { water: 108, electricity: 870, gas: 53 },
      units: [
        {
          unit: "501戶",
          water: 30,
          electricity: 300,
          gas: 15,
          lastYearWater: 28,
          lastYearElectricity: 280,
          lastYearGas: 13,
          lastMonthWater: 29,
          lastMonthElectricity: 290,
          lastMonthGas: 14,
        },
        {
          unit: "502戶",
          water: 40,
          electricity: 290,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 270,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 280,
          lastMonthGas: 19,
        },
        {
          unit: "503戶",
          water: 40,
          electricity: 290,
          gas: 20,
          lastYearWater: 38,
          lastYearElectricity: 270,
          lastYearGas: 18,
          lastMonthWater: 39,
          lastMonthElectricity: 280,
          lastMonthGas: 19,
        },
        {
          unit: "504戶",
          water: 32,
          electricity: 250,
          gas: 16,
          lastYearWater: 30,
          lastYearElectricity: 230,
          lastYearGas: 14,
          lastMonthWater: 31,
          lastMonthElectricity: 240,
          lastMonthGas: 15,
        },
        {
          unit: "505戶",
          water: 45,
          electricity: 320,
          gas: 22,
          lastYearWater: 42,
          lastYearElectricity: 300,
          lastYearGas: 20,
          lastMonthWater: 44,
          lastMonthElectricity: 310,
          lastMonthGas: 21,
        },
        {
          unit: "506戶",
          water: 38,
          electricity: 280,
          gas: 18,
          lastYearWater: 35,
          lastYearElectricity: 260,
          lastYearGas: 16,
          lastMonthWater: 37,
          lastMonthElectricity: 270,
          lastMonthGas: 17,
        },
      ],
    },
  ];
}
